import React from 'react';
import './Blogs.scss';
import { useState } from 'react';
import flagAr from '../../assets/courses/argentina-flag.png';
import flagVe from '../../assets/courses/venezuela-flag.png';
import flagCo from '../../assets/courses/colombia-flag.png';
import flagSal from '../../assets/courses/el-salvador-flag.png';

const cursosData = {
  venezuela: [
    {
      ciudad: 'Valencia - Venezuela',
      fecha: '23, 24 y 25 de Octubre 2025',
      modalidad: 'Presencial',
      descripcion: 'Odontología restauradora desde el diagnóstico, curso sobre directas e indirectas posteriores',
      imagen: flagVe,
      flag: flagVe,
      link: 'https://wa.me/584144191951?text=Hola%20quiero%20info%20sobre%20curso%20de%20posteriores%20de%20la%20Dra%20Fioreella'
    },
  ],
  salvador: [
    {
      ciudad: 'San Salvador - El Salvador',
      fecha: '19, 20 y 21 de Julio 2025',
      modalidad: 'Presencial',
      descripcion: 'Actualización de estetica en sector anterior',
      imagen: flagSal,
      flag: flagSal,
      link: 'https://wa.me/5493517553010?text=Info%20sobre%20curso%20de%20la%20Dra%20Fioreella'
    },
    
  ],
  argentina: [
    {
      ciudad: 'CABA - Argentina',
      fecha: '7, 8 y 9 de Agosto 2025',
      modalidad: 'Presencial',
      descripcion: 'Odontología restauradora desde el diagnóstico, curso sobre anteriores directos',
      imagen: flagAr,
      flag: flagAr,
      link: 'https://wa.me/5491126412362?text=Info%20sobre%20curso%20de%20la%20Dra%20Fioreella'
    },
    
  ]
};
  

const Blogs = () => {

    const [paisActivo, setPaisActivo] = useState('argentina');
    return (
        <>
        <section className='service-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="1000" id="courses">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className='fw-bold'>Cursos</h2>
          <p className='mb-3 mt-3'>Elige el país:</p>
          <div className="d-flex justify-content-center gap-4 flex-wrap">
            {Object.keys(cursosData).map((pais) => (
              <button
                key={pais}
                onClick={() => setPaisActivo(pais)}
                className={`border-0 bg-transparent pb-1 ${paisActivo === pais ? 'fw-bold border-bottom' : 'text-muted'}`}
                style={{ fontSize: '1.1rem' }}
              >
                {pais.charAt(0).toUpperCase() + pais.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="row">
          {cursosData[paisActivo].map((curso, index) => (
            <div className='col-lg-4 col-md-6 col-sm-6 mb-4' key={index}>
              <div className="blog-card h-100 d-flex flex-column">
                <div className="blog-text">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="fw-bold mb-0">{curso.ciudad}</h5>
                    <img src={curso.flag} alt="bandera" style={{ width: '64px' }} />
                  </div>
                  <p className="fw-semibold mb-2">{curso.fecha}</p>

                  <span className="badge bg-danger text-white mb-2" style={{ fontSize: '0.75rem' }}>
                    {curso.modalidad}
                  </span>

                  <p style={{ whiteSpace: 'pre-line' }}>{curso.descripcion}</p>
                </div>
                <div className='theme-btn'>
                  <a
                    className="btn btn-sm btn-outline-primary mt-3"
                    href={curso.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Más Información
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </>
    );
};

export default Blogs;